import SharedStateBridge, { BridgeContextProvider, useBridgeContext } from '@sendible/shared-state-bridge';
import { useEffect } from 'react';
import { EVENTS, publish } from '@sendible/event-manager';
import PhotoInitialiser from './photoInitialiser';
import VideoInitialiser from './videoInitialiser';
import { MediaLibraryProvider } from '../../pages/MediaLibrary/context';
import { BackgroundUploaderProvider } from '../BackgroundUploader/context';
import { loadTranslations } from '../../i18n';
import { UploadsProvider } from '../../models/uploads/uploadsContext';

export const EDITOR_EXPORT = 'creative-editor-export';
export const EDITOR_VIDEO_EXPORT = 'creative-editor-export-video';
export const EDITOR_CLOSE = 'creative-editor-export-close';
export const EDITOR_CLOSE_VIDEO = 'creative-editor-export-close-video';
export const EDITOR_CLOSE_WITH_ERROR = 'creative-editor-export-close-error';
export const EDITOR_OPEN = 'open-editor';
export const EDITOR_VIDEO_OPEN = 'open-video-editor';

const TranslateWrapper = () => {
  const [sharedState] = useBridgeContext();

  useEffect(() => {
    loadTranslations(sharedState?.user?.language);
  }, [sharedState?.user?.language]);

  return (
    <>
      <PhotoInitialiser />
      <VideoInitialiser />
    </>
  );
};

const Editor = () => {
  const newContext = SharedStateBridge.getSharedState();

  useEffect(() => {
    window.addEventListener('storage', ({ key }) => {
      if (key === 'shared-state') {
        publish(EVENTS.SHARED_STATE_CHANGED, null);
      }
    });
  }, []);

  return (
    <BridgeContextProvider initialState={newContext}>
      <UploadsProvider>
        <MediaLibraryProvider>
          <BackgroundUploaderProvider>
            <TranslateWrapper />
          </BackgroundUploaderProvider>
        </MediaLibraryProvider>
      </UploadsProvider>
    </BridgeContextProvider>
  );
};

export default Editor;
